import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';

export const getCouponValues = (coupon?: Coupon | null) => {
  if (!coupon) {
    return {};
  }

  switch (coupon.type?.$case) {
    case 'simpleCoupon': {
      const simpleCoupon = coupon.type.simpleCoupon;
      return {
        discount: simpleCoupon.discountValue,
        headline: simpleCoupon.headline,
        categoryName: simpleCoupon.brandAndCategory?.categoryName,
        expiryDate: simpleCoupon.expiryDate,
        brand: {
          name: simpleCoupon.brandAndCategory.brands[0]?.name,
          image: simpleCoupon.brandAndCategory.brands[0]?.image,
        },
        info: simpleCoupon.info,
        redeemableDevices: simpleCoupon.redeemableDevices,
        promotionId: simpleCoupon.couponPromotionId,
      };
    }
    case 'hotDealCoupon': {
      const hotDealCoupon = coupon.type.hotDealCoupon;
      return {
        discount: hotDealCoupon.discountValue,
        headline: hotDealCoupon.headline,
        expiryDate: hotDealCoupon.expiryDate,
        brand: {
          name: hotDealCoupon.productAndBrandInformation.brand.name,
          image: hotDealCoupon.productAndBrandInformation.brand.blackLogoImage,
        },
        info: hotDealCoupon.info,
        redeemableDevices: hotDealCoupon.redeemableDevices,
        promotionId: hotDealCoupon.couponPromotionId,
      };
    }
    case 'minimumOrderValueCoupon': {
      const movCoupon = coupon.type.minimumOrderValueCoupon;

      const activeTier = movCoupon.tiers.find(
        tier => tier.type?.$case === 'active',
      );

      return movCoupon.tiers.length === 1
        ? {
            discount: movCoupon.tiers[0]?.discountValue,
            discountCondition: movCoupon.tiers[0]?.condition,
            headline: movCoupon.headline,
            categoryName: movCoupon.brandAndCategory?.categoryName,
            expiryDate: movCoupon.expiryDate,
            brand: movCoupon.brandAndCategory
              ? {...movCoupon.brandAndCategory.brands[0]}
              : undefined,
            info: movCoupon.info,
            redeemableDevices: movCoupon.redeemableDevices,
            promotionId: movCoupon.couponPromotionId,
          }
        : {
            expiryDate: movCoupon.expiryDate,
            brand: movCoupon.brandAndCategory
              ? {
                  ...movCoupon.brandAndCategory.brands[0],
                }
              : undefined,
            info: movCoupon.info,
            redeemableDevices: movCoupon.redeemableDevices,
            promotionId: movCoupon.couponPromotionId,
            discount: activeTier?.discountValue,
          };
    }
    case 'highTierCoupon': {
      const highTierCoupon = coupon.type.highTierCoupon;

      const discountValue = (() => {
        if (highTierCoupon.discount?.$case === 'tiers') {
          const activeTier = highTierCoupon.discount.tiers.tiers.find(
            tier => tier.type?.$case === 'active',
          );

          if (activeTier) {
            return {
              discount: activeTier.discountValue,
              discountCondition: activeTier.condition,
            };
          }

          return highTierCoupon.discount.tiers.tiers.length === 1
            ? {
                discount: highTierCoupon.discount.tiers.tiers[0]?.discountValue,
                discountCondition:
                  highTierCoupon.discount.tiers.tiers[0]?.condition,
              }
            : {};
        } else {
          return {
            discount: highTierCoupon.discount?.relativeDiscount,
          };
        }
      })();

      return {
        ...discountValue,
        headline: highTierCoupon.headline,
        expiryDate: highTierCoupon.expiryDate,
        info: highTierCoupon.info,
        redeemableDevices: highTierCoupon.redeemableDevices,
        promotionId: highTierCoupon.couponPromotionId,
      };
    }
    default:
      return {};
  }
};
